import React, { useState, useContext } from "react";
import Application from "../../../StateContext/Application";

const Refuncheck = (props) => {
  const statecalls = useContext(Application);
  const { RefundTaxData } = statecalls;
  const [paymenttable, setPaymentTable] = useState([]);
  const [paymentdata, setPaymentData] = useState({});

 

async function AllPaymentTable(e) {
    e.preventDefault()
    try {
      let data = await RefundTaxData(paymentdata.para);
      setPaymentTable(data);
    } catch (error) {
      console.error(error);
    }
  }
  

  return (
    <>
        <div style={{backgroundColor:"#f6f8fc",padding:"50px"}}>
            <div style={{ display: "grid" ,borderRadius:"20px",border:"none",padding:"20px",backgroundColor:'white'}}>
                <div style={{ display: 'grid' }}>
                    <div>
                        <label className='heading'>Search Refund Data</label>
                        <form onSubmit={AllPaymentTable} style={{width:'100%'}} className='my-3'>
                            <input className='mb-3 form-control ' style={{ display: "flex", justifyContent: "center" }} type='search' id="para" placeholder='Enter Tender Name' onChange={(e)=>setPaymentData({...paymentdata,[e.currentTarget.id]:e.target.value})}/>
                            <button className="btn btn-primary" style={{backgroundColor:"#e73d26",border:"none"}}>Search</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
      <div style={{backgroundColor:"#f6f8fc",padding:"50px"}}>
        <table className="table table-bordered" style={{ overflow:"auto"}}>
          <thead>
            <tr>
              <th>Sr.No.</th>
              <th>Scheme ID</th>
              <th>Scheme Name</th>
              <th>TXN ID</th>
              <th>cmsRef</th>
              <th>Account Number</th>
              <th>Pan Card</th>
              <th>Account Holder Name</th>
              <th>IFSC Code</th>
              <th>Refund Amount</th>
              <th>Email</th>
              <th>Contact</th>
              <th>Status</th>
              <th>statusDesc</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {
            paymenttable && paymenttable.map((e,index) => {
                return (
                  <tr key="index">
                    <td>{index+1}</td>
                    <td>{e.Tender_Name}</td>
                    <td>{e.Tender_ID}</td>
                    <td>{e.txnid}</td>
                    <td>{e.cmsRef}</td>
                    <td>{e.AccNumber}</td>
                    <td>{e.PANCARD}</td>
                    <td>{e.Account_HolderName}</td>
                    <td>{e.IFSC_CODE}</td>
                    <td>{e.refund_amount}</td>
                    <td>{e.email}</td>
                    <td>{e.Contact}</td>
                    <td>{e.status}</td>
                    <td>{e.statusDesc}</td>
                    <td>{e.Date}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Refuncheck;
